const debug = require('airship/modules/debug')
const debugLog = require('airship/modules/debug-log').default

const FALSEY_FLAG_MESSAGE =
  'a falsey value was given for a waffle flag; this is probably not intentional'

module.exports = window.waffle
  ? {...window.waffle, flag_is_active: flagIsActive}
  : {flag_is_active: flagIsActive}

function flagIsActive(flag, ...args) {
  if (!flag) {
    if (debug()) throw new Error(FALSEY_FLAG_MESSAGE)

    debugLog(FALSEY_FLAG_MESSAGE)
    return false
  }

  // ensure if for some reason waffle isn't on our window, we don't blow up.
  // just treat all flags as disabled.
  if (!window.waffle) return false

  return window.waffle.flag_is_active(flag, ...args)
}
